/**
 * The sample workspace: a tab that asked for it opens the app on invented families answered
 * in the page (`mock/browser.ts`), until it leaves. The choice lives in this tab's session
 * storage, so another tab, or this one after leaving, is the real app.
 */
const KEY = "estatelark-sample";

export function demoAsked(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** Opens the sample workspace on Today, with a full load so no real answer is kept. */
export function openDemo() {
  try {
    window.sessionStorage.setItem(KEY, "1");
  } catch {
    return;
  }
  window.location.assign("/today");
}

/** Back to the real app, where the account's own session is waiting untouched. */
export function leaveDemo() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Nothing kept, nothing to clear.
  }
  window.location.assign("/");
}
